<div class="container">
  <div class="top-header">
    <app-back-arrow-button
      [label]="'TGA.BackToTGAInsights' | translate"
      [action]="navigateToTGAInsights"
    ></app-back-arrow-button>
    <app-crop-year-selector [readOnly]="true" />
  </div>
  <h1>{{ 'TGA.Selection.Title' | translate }}</h1>

  <div class="tab-container">
    @for (tab of data(); track $index) {
      <button class="tab-button" mat-button [class.active]="isTabActive($index)" (click)="selectTab($index)">
        {{ 'TGA.Selection.' + tab.translationKey + '.Name' | translate }}
      </button>
    }
  </div>

  <div class="tga-sections-wrapper">
    <div class="tab-content">
      @for (section of activeSections(); track $index) {
        <div class="part-section">
          <h2>{{ sectionTranslationKeys()[$index] + '.Title' | translate }}</h2>

          @if (
            (sectionTranslationKeys()[$index] + '.Subtitle' | translate) !==
            sectionTranslationKeys()[$index] + '.Subtitle'
          ) {
            <p class="part-sublabel">{{ sectionTranslationKeys()[$index] + '.Subtitle' | translate }}</p>
          }

          <div class="items-grid">
            @for (item of section.items; track item.label) {
              <button mat-button class="item-card" (click)="onItemClick(item)">
                <div class="item-info">
                  <div class="item-label">{{ item.label }}</div>
                  @if (item.sublabel) {
                    <div class="item-sublabel">{{ item.sublabel }}</div>
                  }
                </div>
                <div class="item-action">
                  <p class="action-label">{{ activeTabTranslationKey() + '.Action' | translate }}</p>
                  <mat-icon class="icon">arrow_forward</mat-icon>
                </div>
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
